import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { mediaQueries } from '../../../styles/media-queries';

import { Flexbox } from '../../Flexbox';
import { Button } from '../../Button';

export const ImageWrapper = styled(Flexbox)`
  align-items: center;
  justify-content: center;
  position: relative;
  height: ${pxToRem(148)};
  width: ${pxToRem(148)};
`;

export const SpinningBadge = styled('div')`
  position: absolute;
  z-index: 1;
  animation: rotation 8s infinite linear;

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;

export const WhiteCheckmark = styled('div')`
  position: absolute;
  z-index: 2;
  margin-top: ${pxToRem(10)};
`;

export const FormWrapper = styled(Flexbox)`
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: fit-content;
  background-color: ${({ theme }) => theme.color.white};
  border-radius: ${pxToRem(24)};
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.16);

  ${mediaQueries.desktop} {
    border-radius: ${({ theme }) => theme.borderRadius.innerBlock};
  }
`;

export const StyledForm = styled('form')`
  display: flex;
  flex-direction: column;
  margin-top: ${pxToRem(40)};
`;

export const SubmitButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'error'
})<{ error?: boolean }>`
  height: ${pxToRem(64)};
  margin-top: ${({ theme }) => theme.spacing.ml};
  border-radius: ${({ theme }) => theme.borderRadius.button};

  ${mediaQueries.desktop} {
    height: ${pxToRem(64)};
  }
`;
